//frontend/src/pages/Procurement/routes.jsx

import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import "../../components/AdminRequests/AdminRequests.css";

import Chat from "../../components/Chat/Chat";

import SearchManagerRequestsList from "../../components/SearchManagerRequests/SearchManagerRequestsList";
import SearchManagerRequestDetail from "../../components/SearchManagerRequests/SearchManagerRequestDetail";

function ProcurementDashboard() {
  const navigate = useNavigate();

  return (
    <div className="proc-page">
      <div className="proc-page__header">
        <div>
          <div className="proc-breadcrumb">Procurement / Обзор</div>
          <h1>Обзор</h1>
          <p>Рабочее пространство менеджера по поиску товаров</p>
        </div>
      </div>

      <section className="proc-section">
        <div className="proc-section__title">
          <div>
            <h2>Быстрый доступ</h2>
            <span>Основные рабочие разделы</span>
          </div>
        </div>

        <div
          style={{ padding: 16, display: "flex", gap: 10, flexWrap: "wrap" }}
        >
          <button
            type="button"
            className="proc-button proc-button--secondary"
            onClick={() => navigate("/procurement/requests")}
          >
            ▣ Заявки на поиск
          </button>
          <button
            type="button"
            className="proc-button proc-button--secondary"
            onClick={() => navigate("/procurement/chat")}
          >
            💬 Чат
          </button>
        </div>
      </section>

      <div className="proc-empty proc-empty--large">
        <div className="proc-empty__icon">🛒</div>
        <h3>Раздел в разработке</h3>
        <p>Поставщики, товары и календарь пока недоступны.</p>
      </div>
    </div>
  );
}

function ProcurementChatRoute() {
  return (
    <div className="proc-page">
      <div className="proc-page__header">
        <div>
          <div className="proc-breadcrumb">Procurement / Чат</div>
          <h1>Чат</h1>
          <p>Переписка с поставщиками и участниками закупок</p>
        </div>
      </div>
      <Chat />
    </div>
  );
}

export default function ProcurementRoutes() {
  return (
    <Routes>
      <Route index element={<ProcurementDashboard />} />

      {/* Заявки на поиск (только чтение для менеджера) */}
      <Route path="requests" element={<SearchManagerRequestsList />} />
      <Route
        path="requests/:id"
        element={<SearchManagerRequestDetail />}
      />

      <Route path="chat" element={<ProcurementChatRoute />} />
      <Route path="*" element={<Navigate to="/procurement" replace />} />
    </Routes>
  );
}